import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { CleanButton, Label } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'

import { Loader, Alert, PrimaryButton } from '../../components/default'
import { FormEditProductTable } from '../forms'
import { acPutUpdateProductTable } from '../../class/actions'


function EditProductTableModal({
  classes, open, onClose,
  cachedProductTable,
  updatingProductTable, updatedProductTableError
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const updateProductTable = () => {
    dispatch(acPutUpdateProductTable(cachedProductTable.product_table_id, {
      ...cachedProductTable,
      product_table_id: undefined
    }))
    .then(onClose)
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.productTable.edit.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={12}>
              <FormEditProductTable />
            </Grid>
          </Grid>
        </Box>

        <div>
          <div style={{ marginTop: '15px' }}>
            {
              updatedProductTableError &&
              (updatedProductTableError.message ? (
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={updatedProductTableError.message} />
              ) : updatedProductTableError.errors ? (
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={t('modals.productTable.create.unknownError')} />
              ) : null)
            }
          </div>
          <div style={{ marginTop: '15px' }}>
            <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
              <PrimaryButton onClick={updateProductTable}>
                {
                  updatingProductTable ? (
                    <Loader />
                  ) : (
                    <div>
                      {t('modals.productTable.edit.action')}
                    </div>
                  )
                }
              </PrimaryButton>
            </Grid>
          </div>
        </div>
      </Paper>
    </Modal >
  )
}

EditProductTableModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

EditProductTableModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
    maxHeight: '90%',
    overflowY: 'scroll'
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  urlLabel: {
    padding: theme.spacing(1),
    overflowWrap: 'break-word',
    cursor: 'pointer'
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '50%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  },
  centeredDiv: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column'
  },
  successCircle: {
    color: theme.palette.success.main,
    fontSize: '80px'
  }
})

const mapStateToProps = ({ ReducerProductTable }) => ({
  cachedProductTable: ReducerProductTable.cachedProductTable,
  updatingProductTable: ReducerProductTable.updatingProductTable,
  updatedProductTableError: ReducerProductTable.updatedProductTableError
})

export default connect(mapStateToProps)(withStyles(styles)(EditProductTableModal))